
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.103 18.6c-.26 0-.51-.099-.71-.288a.989.989 0 010-1.404l7.999-7.964a.999.999 0 011.41 0l7.978 7.944a.988.988 0 010 1.404.999.999 0 01-1.41 0l-7.269-7.238-7.288 7.258c-.2.19-.46.289-.71.289z"}})])
          )
        }
      }
    